import { api } from './api';

const CustomersService = {
//   updateAppInfo: (params: any) => {
//     return api.authPutForm('/auth/owner/app', params);
//   },
  
  getListCustomers: (params?: any) => {
    // return api.authGet(`/auth/owner/group/customers-app/?page=${params?.page}&limit=${params?.limit}&search=${params?.search ? encodeURIComponent(params?.search) : ''}`);
    return api.authGet(`/auth/owner/group/customers-app/`, params);
  },
  
  getListGroups: (params?: any) => {
    return api.authGet('/auth/owner/group/', params);
  },
  
  getListBriks: (group_id: any, params?: any) => {
    return api.authGet(`/auth/owner/group/${group_id}/briks`, params);
  },
  
  getListMembers: (group_id: string, params?: any) => {
    return api.authGet(`/auth/owner/group/${group_id}/customers-group/`, params);
  },
  
  getListMembersApp: (group_id: any, params?: any) => {
    return api.authGet(`/auth/owner/group/${group_id}/customers-invite/`, params);
  },
  
  getUserAcount: (user_id: any) => {
    return api.authGet(`/auth/owner/group/user/${user_id}/count`);
  },
  
  getBrikPage: (user_id: any, brik_id: any) => {
    return api.authGet(`/auth/owner/group/user/${user_id}/brik/${brik_id}`);
  },

  createGroup: (params: any) => {
    return api.authPostForm('/auth/owner/group', params);
  },

  inviteMember: (group_id: any, params: any) => {
    return api.authPost(`/auth/owner/group/${group_id}/invite`, params);
  },

  inviteCustomer: (params: any) => {
    return api.authPost(`/auth/owner/app/invite`, params);
  },

  getListBriksAddToGroup: (group_id: any, params?: any) => {
    return api.authGet(`/auth/owner/group/${group_id}/briks-already-invited`, params);
  },

  addBrikToGroup: (group_id: any, params: any) => {
    return api.authPost(`/auth/owner/group/${group_id}/briks`, params);
  },
};

export default CustomersService;
